// Runtime configuration resolver.
//
// The image is built ONCE (config baked as undefined). Per-instance values are
// injected at container start into `window.__APP_CONFIG__` (see public/config.js,
// generated by entrypoint.sh from the VUE_APP_* env vars k8s/Helm provide).
//
// `cfg()` keeps the STATIC `process.env.VUE_APP_X` token on the call site so that:
//   - webpack/DefinePlugin still inlines it (no dynamic process.env access), and
//   - `yarn dev` + `.env` local development keeps working unchanged (build-with-env),
// while a runtime override in `window.__APP_CONFIG__` takes precedence in production.
//
// Resolution order: window.__APP_CONFIG__[key]  ->  build-time value  ->  undefined.
//
// Overloaded so the return type mirrors the build-time value: `process.env.VUE_APP_X`
// is typed `string` in this project, so `cfg('X', process.env.VUE_APP_X)` is `string`
// (preserving the original config typing for consumers). At runtime the value can
// still be undefined, so trailing `?? default` patterns continue to work.
export function cfg (key: string, buildValue: string): string
export function cfg (key: string, buildValue?: string): string | undefined
export function cfg (key: string, buildValue?: string): string | undefined {
  const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__)
    ? window.__APP_CONFIG__[key]
    : undefined
  if (runtime) {
    return runtime
  }
  return buildValue
}
